// @ts-strict-ignore
import { UserModel } from '@user/model/user.model';
import { UserProfileUtils } from '@user/service/user-profile-utils';
import { lastValueFrom, Observable, Subject } from 'rxjs';
import { Injectable } from '@angular/core';
import { ArticleDataService } from '@article/service/article-data.service';
import { UserComponentPresenter } from '../../user-component.presenter';
import { ArticleCollectionVO } from '@article/model/vo/article.vo';

export interface CollectionNotification {
  notification: string,
  collectionId?: number
}
@Injectable({ providedIn:'root' })
export class CollectionService {

  public readonly NOTIFICATION_COLLECTION_UPDATED: string = 'collectionUpdated';
  public readonly NOTIFICATION_ARTICLE_ADDED_TO_COLLECTION: string = 'articleAdded';
  public readonly NOTIFICATION_UPDATE_FAVORITE_ARTICLES: string = 'updateFavoriteArticles';
  public readonly NOTIFICATION_SINGLE_COLLECTION_CHANGED: string = 'singleCollectionChanged'

  private collectionNotificationSubject: Subject<CollectionNotification> = new Subject<CollectionNotification>();

  constructor(
    private userModel: UserModel,
    private articleDataService: ArticleDataService,
    private userComponentPresenter: UserComponentPresenter,
  ) {
  }

  public get collectionNotification$(): Observable<CollectionNotification> {
    return this.collectionNotificationSubject.asObservable();
  }

  public notifyCollectionUpdated(): void {
    const notification: CollectionNotification = { notification: this.NOTIFICATION_COLLECTION_UPDATED };
    this.collectionNotificationSubject.next(notification);
  }

  public isArticleInCollection(article: number): boolean {
    return UserProfileUtils.isArticleInAnyCollection(this.userModel.userProfile, article);
  }

  public notifyArticleAddedToCollection(): void {
    const notification: CollectionNotification = { notification: this.NOTIFICATION_ARTICLE_ADDED_TO_COLLECTION };
    this.collectionNotificationSubject.next(notification);
  }

  public notifyUpdateFavoriteArticles(): void {
    const notification: CollectionNotification = { notification: this.NOTIFICATION_UPDATE_FAVORITE_ARTICLES };
    this.collectionNotificationSubject.next(notification);
  }

  public notifySingleCollectionChanged(collectionId?: number): void {
    const notification: CollectionNotification = {
      notification: this.NOTIFICATION_SINGLE_COLLECTION_CHANGED,
      collectionId: collectionId
    };
    this.collectionNotificationSubject.next(notification);
  }

  public async addArticleToArticleCollection(articleId: number): Promise<ArticleCollectionVO> {
    const availableArticleCollections = UserProfileUtils.getAvailableArticleCollectionsForAddingArticleByUserAndId(
      this.userModel.userProfile,
      articleId,
    );
    const article = await lastValueFrom(this.articleDataService.loadArticleByArticleId(articleId));
    const articleCollection = await this.userComponentPresenter.presentAddArticleToArticleCollectionPopup(article, availableArticleCollections);
    this.notifyArticleAddedToCollection();
    return articleCollection;
  }
}
